























import { Component, Vue, Prop } from "vue-property-decorator";

import Header from "./Header.vue";

import Checkbox from "@/components/inputs/Checkbox.vue";

import { OrderHeader } from "@/store/account/orders/types";
import { HeaderKeys } from "@/store/account/orders/enums";
import { SortDirections } from "@/store/catalog/enums";

@Component({ components: { Header, Checkbox } })
export default class OrderTableHeaders extends Vue {
  tooltip = false;

  @Prop({ type: Array, default: () => [] })
  readonly headers!: OrderHeader[];

  @Prop({ type: Boolean, default: true })
  readonly selectable!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isSelected!: boolean;

  @Prop({ type: String, default: "" })
  readonly sortKey!: HeaderKeys;

  @Prop({ type: String, default: SortDirections.DESC })
  readonly sortDirection!: SortDirections;

  onEnter(key: HeaderKeys) {
    this.tooltip = true;
    this.$emit("highlight", { cell: key, state: true });
  }

  onLeave(key: HeaderKeys) {
    this.tooltip = false;
    this.$emit("highlight", { cell: key, state: false });
  }

  sort(key: HeaderKeys) {
    this.$emit("sort", {
      key,
      order: this.sortDirection || SortDirections.DESC,
    });
  }

  selectHandler(value: boolean) {
    this.$emit("select", { id: null, value });
  }
}
